// Lightweight call/form tracking for GA4 + PostHog.
// Silent no-op if analytics libraries aren't loaded, so it never breaks the page.

function getCurrentPageSlug() {
  if (typeof window === 'undefined') return 'unknown';
  const p = window.location.pathname.replace(/^\/+|\/+$/g, '');
  return p || 'home';
}

/**
 * Fire a `generate_lead` event on both GA4 (gtag) and PostHog.
 *
 * @param {object} opts
 * @param {'phone_click'|'form_submit'|'form_open'} opts.method  How the lead was initiated
 * @param {string} [opts.location]  Where on the page (hero, sticky_bar, emergency_banner, header, footer_cta)
 * @param {object} [opts.extra]     Any extra payload (service, zipCode, lead_id)
 */
export function trackLead({ method, location = 'unknown', extra = {} } = {}) {
  try {
    const page_slug = getCurrentPageSlug();
    const payload = {
      method,
      location,
      page_slug,
      page_path: typeof window !== 'undefined' ? window.location.pathname : '',
      ...extra,
    };

    // GA4
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', payload);
    }

    // PostHog
    if (typeof window !== 'undefined' && window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture('generate_lead', payload);
    }

    // Dev visibility
    if (typeof console !== 'undefined' && console.debug) {
      console.debug('[track]', 'generate_lead', payload);
    }
  } catch (err) {
    // Never let tracking break the UX
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('trackLead failed:', err);
    }
  }
}
